import type { Paths } from '@/core/types/gengeric';
import { deepEqual, getNestedObjectProperty } from '@/core/utils/object';
import { isObject } from '@/core/utils/type-guards';

export const getSelectFilterItems2 = <T extends Record<string, unknown>, K extends Paths<T>>(
  array: T[],
  key: K,
): T[K][] =>
  array.reduce<T[K][]>((res, item) => {
    const value = getNestedObjectProperty(item, key);

    if (value && !res.some((x) => deepEqual(x, value))) {
      res.push(value);
    }

    return res;
  }, []) as T[K][];

// DEPRECATED / удаллить при рефакторинге
export const getSelectFilterItems = <T>(array: T[], key: string, returnKey?: keyof T) => {
  return array.reduce((res, item) => {
    let returnObj = item as never;

    if (returnKey && isObject(item)) {
      returnObj = item[returnKey] as never;
    }

    if (!res.some((resItem) => key in returnObj && resItem[key] === returnObj[key])) {
      res.push(returnObj);
    }

    return res;
  }, []);
};
